var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showImage"}},[(this.hasBackgroundImage)?_c('img',{attrs:{"id":"bg-img","srcset":this.image}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }